var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":"字体大小"}},[_c('avue-input-number',{model:{value:(_vm.main.activeOption.fontSize),callback:function ($$v) {_vm.$set(_vm.main.activeOption, "fontSize", $$v)},expression:"main.activeOption.fontSize"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }